module.exports = __webpack_public_path__ + "img/product_2.e97f7761.svg";